export default (props, vars) =>
  vars?.['applicationcard2']?.['item'].company_logo;
